interface Props {
  readonly size?: number;
}

export default function OrdersIcon(props: Props) {
  const { size = 16 } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63371 3.472L8.78902 2.4H7.21017L6.3671 3.472H5.02507C5.02507 3.472 6.49498 1.6952 6.69155 1.4544C6.84154 1.2704 6.99467 1.2 7.19361 1.2H8.80639C9.00612 1.2 9.15928 1.2704 9.30927 1.4544C9.50504 1.6952 10.9757 3.472 10.9757 3.472H9.63371ZM10.5005 1.208L9.82238 0.447201C9.56029 0.0688008 9.27609 0 8.72271 0H7.27729C6.7247 0 6.4397 0.0688008 6.17841 0.447201L5.5003 1.208C3.47149 1.5672 2 2.52 2 3.2232V3.3592C2 4.5968 4.68641 5.6 7.99961 5.6C11.3136 5.6 14 4.5968 14 3.3592V3.2232C14 2.52 12.5293 1.5672 10.5005 1.208ZM2.78074 5.6904L3.64991 14.4168C3.69807 14.7856 5.45531 15.9984 7.99961 16C10.5455 15.9984 12.3027 14.7856 12.3501 14.4168L13.22 5.6904C11.8907 6.444 9.90369 6.8 7.99961 6.8C6.09711 6.8 4.10933 6.444 2.78074 5.6904Z"
        fill="currentColor"
      />
    </svg>
  );
}
